import React from 'react';
import { useNavigation } from 'common/hooks/useNavigation';
import { ImageConstants } from 'common/ImageConstants';
import { useLocalizedStrings } from 'i18n';
import { dashboardPath } from 'Routes';

import ErrorBasePage from './ErrorBasePage';

export const ErrorPage500: React.FunctionComponent = () => {
  const { goBack } = useNavigation();
  const { t } = useLocalizedStrings();

  const goToDashboard = () => {
    window.location.href = dashboardPath;
  };

  return (
    <ErrorBasePage
      headerText={t('Errors.500Error.HeaderFirstLine')}
      detailsMessage={t('Errors.500Error.Details')}
      imageFileName={ImageConstants.ExclamationMark}
      primaryButton={{
        text: t('Errors.ReloadPage'),
        onClick: () => goBack(),
      }}
      secondaryButton={{
        text: t('GoToHome'),
        onClick: goToDashboard,
      }}
    />
  );
};

export default ErrorPage500;
